
export const handleButtonClick = (button, setActiveButton) => {
    setActiveButton(button);
};